export default {
    h1: 'Instalar la tutoría 1 a 1 en línea ',
    desc: 'Para cuandoquiera su hijo/hija necesite ayuda',
    button: 'Agendar una clase de prueba',
    title1: 'Garantía de seguridad',
    title2: 'Como se ha visto',
    name: 'Tutores examinados',
    list: [
        [
            {
                name: 'Tutores examinados',
                desc: `La solicitud de cada tutor para ser profesor ha sido revisada. Nuestra comunidad de tutores tiene profesores certificados, profesionales y algunos son estudiantes de las universidades prestigiosas quienes serán individualmente evaluados y entrenados.`
            },
            {
                name: 'Comunicación segura',
                desc: `Todas las comunicaciones se darán a través de la plataforma segura de
                Airclass. Nuestro sistema está configurado para prohibir cualquier 
               comunicación inapropiada o intercambiar informaciones personales.
               `
            },
            {
                name: '24/7 Asistencia',
                desc: `El equipo Airclass siempre estará disponible para responder cualquier tu
                pregunta, preocupaciones o ideas. No sólamente estamos aquí para 
                preguuta sino tambien ayudarle a seguir los pasos correctos de la 
                enseñanza.`
            },
        ],
        [
            {
                title: 'Espacio para cursos avanzados',
                desc: `Nuestra aula virtual renovable proporciona una experiencia con más confianza
                en la que se realiza una tutoría individualizada.`
            },
            {
                title: 'Asesores de curso',
                desc: `Airclass ayudará a estudiantes fuera de clase también. Nuestro asesores 
                ayudarán a los estudiantes en la reserva de clases, capacidadas
                 académicas y trayectorias profesionales.`
            },
            {
                title: 'Tutores de las mejores universidades',
                desc: `Tutores altamente cualificados de las mejores universidades por todo el 
                mundo están preparadaos para ofercer ayuda. Un ratio de aprobación de 
                7,8% significa que todos nuestros tutores son estrictamente examinados.`
            }
        ]
    ]
}